const RECEIVE_TEMPLATE_BLOCKS = "RECEIVE_TEMPLATE_BLOCKS";
const REQUEST_TEMPLATE_DATA = "REQUEST_TEMPLATE_DATA";

export const BuildTypes = {
  RECEIVE_TEMPLATE_BLOCKS,
  REQUEST_TEMPLATE_DATA
};
